<template>
  <div :class="computedClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  noGutters?: boolean
  hasVerticalGap?: boolean
}>()

const computedClasses = computed(() => [
  'grid grid-cols-12',
  {
    'gap-x-4 sm:gap-x-8': !props.noGutters,
    'gap-y-4 sm:gap-y-8': props.hasVerticalGap,
  },
])
</script>
